/**
 * Accès défensif au stockage local : selon le contexte (navigation privée,
 * environnement de test, politiques de site), `localStorage` peut être absent
 * ou lever une exception. Aucune fonctionnalité critique n'en dépend.
 */
export function readStorage(key: string): string | null {
  try {
    return globalThis.localStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeStorage(key: string, value: string): void {
  try {
    globalThis.localStorage?.setItem(key, value);
  } catch {
    /* stockage indisponible : préférence non mémorisée */
  }
}
